export const randomizeShimmerWidth = (min = 100, max = 150) => {
  return Math.random() * max + min
}
